import { render, staticRenderFns } from "./FeaturesEdit.vue?vue&type=template&id=151b8a4e&scoped=true&"
import script from "./FeaturesEdit.vue?vue&type=script&lang=js&"
export * from "./FeaturesEdit.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesEdit.vue?vue&type=style&index=0&id=151b8a4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b8a4e",
  null
  
)

export default component.exports